export const tenantConfigFn = () => {
  const callApprovalAPI = () => {
    return {
      allowApprovalAPICall: ["medonehp0001"],
    };
  };
  const medonehp0001Config = () => {
    const BILLING_WORK_QUEUE_EVENT_TYPE_ID = 225;
    const DAILY_CHARGE_AND_PAYROLL_CODES_EVENT_TYPE_ID = 218;
    return {
      allowEventTypeEdit: [BILLING_WORK_QUEUE_EVENT_TYPE_ID, DAILY_CHARGE_AND_PAYROLL_CODES_EVENT_TYPE_ID],
    };
  };

  const frontierdrm1Config = () => {
    const PAYMENT_EVENT_TYPE_ID = 4;
    return {
      allowEventTypeEdit: [PAYMENT_EVENT_TYPE_ID],
    };
  };

  return {
    medonehp0001: medonehp0001Config,
    frontierdrm1: frontierdrm1Config,
    callApprovalAPI: callApprovalAPI,
  };
};
